exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  padding-top: 30px;\n  margin-top: 40px;\n  text-align: center;\n}\n\np {\n  letter-spacing: 2px;\n}\n\nimg {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height:670px;\n  width:auto;\n  padding-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/about/about.component.css
// module id = ../../../../../src/app/about/about.component.css
// module chunks = main